import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { fetch_cafe_details, save_cafe_details } from './api';
import type { CafeDetailsRequest } from './types';

const KEY = ['module-details', 'cafe'] as const;

export function use_save_cafe_details() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: CafeDetailsRequest) => save_cafe_details(input),
    onSuccess: () => {
      // Rail's module_details_completed[CAFE] flag just changed.
      qc.invalidateQueries({ queryKey: ['onboarding', 'draft'] });
      qc.invalidateQueries({ queryKey: KEY });
    },
  });
}

export function use_cafe_details(options?: { enabled?: boolean }) {
  return useQuery({
    queryKey: KEY,
    queryFn: fetch_cafe_details,
    staleTime: 0,
    retry: 0,
    enabled: options?.enabled ?? true,
  });
}
